export class BeanJustificativa{
    constructor(
      public justIdCdJustificativa: number,
      public justDsJustificativa: string,
      public justDhInativo: string,
      public justDhRegistro: string
    ){}
  }